import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import { OTPCheckDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/otpcheck/otpcheckdto';
import { AlertType } from '../../../../toolkit/alert/alerttype';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { FlashMessageOTPVerificationCSSStyleImpl } from './falshmessageotpverificationcss';
import { FlashMessageOTPVerificationAPIModelImpl, FlashMessageOTPVerificationAPIModel } from './flashmessageotpverificationapimodel';
import { FlashMessageOTPVerificationViewImpl } from './flashmessageotpverificationview';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { UIComponentProps, UIComponentHandler, UIComponentState, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';


export interface FlashMessageOTPVerificationComponentProps extends UIComponentProps
{
    channel?:string;
    flashMessageDto:FlashMessageDto;
    closePopup():void;
    showPopup(id:string,msg:string,type:AlertType):void;
}

export interface FlashMessageOTPVerificationComponentHandler extends UIComponentHandler
{
    onConfirmClick():void;
    onClosePopup():void;
    onResendOtpClick():void;
    
}
export interface FlashMessageOTPVerificationComponentState extends UIComponentState
{
    secToc: string;
    isResendButtonRestricted:boolean;
    countDownTime:number;
}

export class FlashMessageOTPVerificationComponent extends UIComponentImpl<FlashMessageOTPVerificationComponentProps, FlashMessageOTPVerificationComponentState, UIDataModel> implements FlashMessageOTPVerificationComponentHandler
{
    private timer: any;
    private countDownTimerInterval:any;
    private duration = Number(this.getContext().getProperty().getResendOtpTimeout());
    private countDownSeconds = this.duration/1000;

    constructor(props: FlashMessageOTPVerificationComponentProps)
    {
        super(props);

        this.state = {isResendButtonRestricted:true, secToc: props.context.getUserContext().getSecToken(),countDownTime:this.countDownSeconds};
        console.log(this.getContext().getUserContext().getPackName());      
    }

    componentDidMount(): void {
        this.countDownSeconds = this.duration/1000;
            this.startCountDown();
            this.setState({countDownTime:this.countDownSeconds});
          
            this.setState({isResendButtonRestricted:true, secToc: ""});
         
            this.timer = setTimeout(this.setState.bind(this, {isResendButtonRestricted:false}), Number(this.duration));
          
    }
    startCountDown() 
    {
        let countDownTimer = document.getElementById("flashmessage-countdown");

     let formatTime = (time:any) =>
     `${String(Math.floor(time / 60)).padStart(2, "0")}:${String(
       time % 60
     ).padStart(2, "0")}`;
      
        this.countDownTimerInterval= setInterval(async() => {
          
     
          if (this.countDownSeconds < 0 ) {
            clearInterval(this.countDownTimerInterval);
            countDownTimer!==null && (countDownTimer.innerHTML = " ");
        
          }
          else{
           
          
         countDownTimer!==null && (countDownTimer.innerHTML = String(formatTime(this.countDownSeconds--)));
          }
         
        }, 900);
      }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new FlashMessageOTPVerificationViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new FlashMessageOTPVerificationCSSStyleImpl(applicationContext);
    }

    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new FlashMessageOTPVerificationAPIModelImpl(applicationContext, apiModelHandler);
    }
    onConfirmClick():void
    {
        if((this.getView() as FlashMessageOTPVerificationViewImpl).validate())
        {
            (this.getView() as FlashMessageOTPVerificationViewImpl).showLoader(); 
            let otpDto = (this.getView() as FlashMessageOTPVerificationViewImpl).getData() as OTPCheckDtoImpl;
            otpDto.setMsisdn(this.props.flashMessageDto.getMsisdn());
            otpDto.setSecToc(this.state.secToc);
            (this.getAPIModel() as FlashMessageOTPVerificationAPIModel).otpCheck(otpDto);
        }
        
    }
    onClosePopup():void
    {
        this.props.closePopup();
    }
    onResendOtpClick(): void 
    {
       
        if(this.state.isResendButtonRestricted === true)
        {
           
        }
        else
        {
           
           
            (this.getView() as FlashMessageOTPVerificationViewImpl).showLoader(); 
        (this.getAPIModel() as FlashMessageOTPVerificationAPIModel).resendOtp(this.getContext().getUserContext().getMsisdnB());
        }
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        console.log("onSuccess() invoked" + feature);
        (this.getView() as FlashMessageOTPVerificationViewImpl).dismissLoader(); 
        if(feature === APIFeatures.CONFIRM_OTP)
        {
            (this.getView() as FlashMessageOTPVerificationViewImpl).showLoader();

            this.props.flashMessageDto.getIsAllCallers() ?
            (this.getAPIModel() as FlashMessageOTPVerificationAPIModel).generateToken(this.props.flashMessageDto)
            :
            (this.getAPIModel() as FlashMessageOTPVerificationAPIModel).setSpecialCallerFlashMessage(this.props.flashMessageDto);
        }
        else if(feature === APIFeatures.GENERATE_OTP)
        {
            this.countDownSeconds = this.duration/1000;
            this.startCountDown();
            this.setState({countDownTime:this.countDownSeconds});
          
            this.setState({isResendButtonRestricted:true, secToc: ""});
         
            this.timer = setTimeout(this.setState.bind(this, {isResendButtonRestricted:false}), Number(this.duration));
          
        }
        else if(feature === APIFeatures.SET_FLASH_MESSAGE)
        {
            console.log("onSuccess() invoked" + feature);
            this.props.showPopup(this.getContext().getResources().getString(Strings.subscription),
            this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
        }
        else if(feature === APIFeatures.DEDICATE_FLASH_MESSAGE)
        {
            console.log("onSuccess() invoked" + feature);
            this.props.showPopup(this.getContext().getResources().getString(Strings.subscription),
            this.getContext().getResources().getString(Strings.your_order_is_successfully_completed),AlertType.SUCCESS);   
        }
    }

    onFailure(feature: APIFeatures, description: string, data: any): void 
    {
     if(feature === APIFeatures.GENERATE_FLASH_TOKEN || feature === APIFeatures.GENERATE_FLASH_TOKEN)
        {
            (this.getView() as FlashMessageOTPVerificationViewImpl).dismissLoader();
            this.props.showPopup("Note4U OTP",description,AlertType.ERROR);     
        }
        
        else{
        (this.getView() as FlashMessageOTPVerificationViewImpl).dismissLoader(); 
            (this.getView() as FlashMessageOTPVerificationViewImpl).setErrorMsg(description); 
        }
    
    }
    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();
        
        clearTimeout(this.timer);
       
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashotp/flashmessageotpverificationcomponent.tsx